"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @name PIMConstants
 * @type {object}
 * @property {object} BRAND
 * @property {string} BRAND.HEADLINE
 * @property {string} BRAND.BODY
 */
var constants = {
  BRAND: {
    HEADLINE: 'HeadlineConsumer',
    BODY: 'DescriptionConsumer'
  }
};
var _default = constants;
exports["default"] = _default;